var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionHideview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.388 6.56429C16.2632 7.41546 17.4321 8.46594 18.0584 9.66509L18.1449 9.83009L18.0584 9.99347C17.1755 11.6876 15.6076 13.0812 14.2577 14.0418C13.1228 14.8489 11.8595 15.3537 10.5174 15.4779L11.3818 13.8964C12.0559 13.7036 12.696 13.3867 13.2929 12.9603C14.3428 12.2137 15.6571 11.1371 16.3637 9.82846C15.9818 9.12106 15.136 8.48064 14.6443 7.92354L15.388 6.56429ZM3.82536 0H14.4881L11.8642 4.61036C11.0045 4.26401 10.0953 4.07613 9.1521 4.07613C7.56567 4.07613 5.66691 4.60546 4.34953 5.54321C2.99658 6.50384 1.83382 7.8974 0.950928 9.58994L0.864339 9.75494L0.950928 9.91995C1.83382 11.6125 2.99813 13.006 4.34953 13.9667C4.83659 14.313 5.74886 14.6022 6.27922 14.8309L3.46663 19.9804C1.52922 19.7893 0 18.0542 0 15.9598V4.04182C0 1.81833 1.72095 0 3.82536 0ZM17.344 0.717203C18.3429 1.44748 19 2.66786 19 4.04182V15.9598C19 18.1833 17.2791 20.0016 15.1746 20.0016H6.5297L17.344 0.717203ZM6.95955 13.5876L7.60124 12.4114C6.83895 11.8984 6.33179 10.9982 6.33179 9.97223C6.33179 8.37608 7.5564 7.08218 9.06706 7.08218C9.52319 7.08218 9.95459 7.1998 10.3334 7.41055L11.1823 5.86015C10.536 5.60856 9.85409 5.47296 9.15055 5.47296C7.91667 5.47296 6.34725 5.88793 5.31437 6.6231C4.26449 7.36971 3.35221 8.44633 2.64559 9.75658C3.35067 11.0668 4.26449 12.1434 5.31437 12.8884C5.71021 13.1694 6.52816 13.4047 6.95955 13.5876ZM9.47062 8.992L10.3334 7.41055C10.0999 7.28149 9.84945 7.18837 9.59123 7.13609C9.40568 7.43179 9.29435 7.78958 9.29435 8.17514C9.29435 8.4692 9.35929 8.74694 9.47062 8.992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionHideview);
export default __webpack_public_path__ + "static/media/question-hideview.940caa0c633255d5f39ce0934e2f88fb.svg";
export { ForwardRef as ReactComponent };